let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("43uod")).then(() => parcelRequire('9feT0'));